import { useEffect, useRef, type RefObject } from 'react';
import { drawSpeechGraph } from './speech-graph';

/**
 * A scrolling loudness graph read from the existing microphone stream without owning its tracks.
 * Every level it measures is added to `history` too.
 */
export function SpeechGraph({
  stream,
  label,
  history,
}: {
  stream: MediaStream;
  label: string;
  history?: RefObject<number[]>;
}) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    return canvas ? drawSpeechGraph(canvas, stream, history?.current) : undefined;
  }, [stream, history]);

  return <canvas ref={canvasRef} className="speech-graph" role="img" aria-label={label} />;
}
